<template>
 <div class="col-md-12 mr-auto ml-auto">
  <div class="wizard-container">
   <div class="card card-wizard active" data-color="primary">
    <Form @submit="onSubmit" :validation-schema="schema">
     <div class="card-body">
      <div class="row">
       <BarraBotoes
        :loadingSave="loadingSave"
        :idRegistroCarregado="$route.params.id"
        :key="keyRV"
        :gridViewLink="'/patrimonio/pattipobem/'+$route.params.patGrupoId"
        @limpar="limparFormulario"
        @excluir="excluir"
       />

       <div class="col-lg-6">
        <div class="col-3 mb-3">
         <div class="form-group">
          <label>Ordem</label>
          <Field
           name="ordem"
           class="form-control"
           type="text"
           v-model="model.ordem"
          />
          <ErrorMessage name="ordem" />
         </div>
        </div>

        <div class="col-3 mb-3">
         <div class="form-group">
          <label>Codigo</label>
          <Field
           name="codigo"
           class="form-control"
           type="text"
           v-model="model.codigo"
          />
          <ErrorMessage name="codigo" />
         </div>
        </div>

        <div class="col-10 mb-3">
         <div class="form-group">
          <label>Descrição</label>
          <Field
           name="descricao"
           class="form-control"
           type="text"
           v-model="model.descricao"
          />
          <ErrorMessage name="descricao" />
         </div>
        </div>

        <div class="col-10 mb-3">
         <div class="form-group">
          <label>Observação</label>
          <Field
           name="observacao"
           as="textarea"
           class="form-control"
           v-model="model.observacao"
           rows="4"
          />
          <ErrorMessage name="observacao" />
         </div>
        </div>
       </div>
      </div>
     </div>
    </Form>
   </div>
  </div>
 </div>
</template>

<script lang="ts">
import { Form, Field, ErrorMessage } from "vee-validate";
import { PatTipoBemModel } from '@/models/patrimonio/pattipobem/pattipobem.model';
import PatTipoBemService from "@/services/patrimonio/pattipobem/pattipobem.service";
import * as yup from "yup";
import { defineComponent } from "vue";
import toastService from "@/services/globals/toast.service";
import BarraBotoes from '@/components/formulario/BarraBotoes.vue';

export default defineComponent({
 name: "InclusaoEdicao",
 components: { BarraBotoes, Form, Field, ErrorMessage },

 data() {
  return {
   schema: yup.object({
    patGrupoId: yup.number().label('PatGrupoId'),
    ordem: yup.number().label('Ordem'),
    codigo: yup.string().max(10).label('Codigo'),
    descricao: yup.string().max(50).label('Descricao'),
    observacao: yup.string().max(1000).label('Observacao'),
   }),
   model: new PatTipoBemModel() as PatTipoBemModel,
   stopSubmit: false,
   loadingSave: false,
   keyRV: 0 as number,
  };
 },

 methods: {
  reload() {
   this.keyRV += 1;
  },

  async carregarProximaOrdem() {
   const patGrupoId = Number(this.$route.params.patGrupoId);

   if (isNaN(patGrupoId) || patGrupoId <= 0) {
    this.model.ordem = 1;
    return;
   }

   try {
    const result = await PatTipoBemService.dadosIndexPaginadoPorGrupo(0, 1000, [], patGrupoId);
    const rows = result.data?.rows ?? [];
    const maiorOrdem = rows.reduce((max, item) => {
     const ordemAtual = Number(item.ordem) || 0;
     return ordemAtual > max ? ordemAtual : max;
    }, 0);

    this.model.ordem = maiorOrdem + 1;
   } catch (error) {
    console.error("Erro ao carregar próxima ordem:", error);
    this.model.ordem = 1;
   }
  },

  setPatGrupoIdFromRoute() {
   const patGrupoId = Number(this.$route.params.patGrupoId);

   if (!isNaN(patGrupoId) && patGrupoId > 0) {
    this.model.patGrupoId = patGrupoId;
   }
  },

  async limparFormulario() {
   const patGrupoId = Number(this.$route.params.patGrupoId);

   this.model = new PatTipoBemModel();

   if (!isNaN(patGrupoId) && patGrupoId > 0) {
    this.model.patGrupoId = patGrupoId;
   }

   await this.carregarProximaOrdem();
   this.reloadRoute();
  },

  reloadRoute(idRegistro: number | null = null) {
   const patGrupoId = Number(this.$route.params.patGrupoId);

   if (idRegistro) {
    this.$router.replace({
     name: 'pattipobem_create',
     params: { patGrupoId, id: idRegistro }
    });
   } else {
    this.$router.replace({
     name: 'pattipobem_create',
     params: { patGrupoId }
    });
   }
  },

  async carregarFormulario() {
   this.setPatGrupoIdFromRoute();

   if (this.$route.params.id) {
    PatTipoBemService.get(this.$route.params.id).then(x => {
     this.model = x;
     this.setPatGrupoIdFromRoute();
    });
   } else {
    this.model = new PatTipoBemModel();
    this.setPatGrupoIdFromRoute();
    await this.carregarProximaOrdem();
   }
  },

  excluir() {
   if (this.$route.params.id) {
    PatTipoBemService.remover(this.$route.params.id).then(() => {
     this.limparFormulario();
     toastService.alertaSucesso('Registro excluído com sucesso!');
    });
   }
  },

  onSubmit() {
   this.model.patGrupoId = Number(this.$route.params.patGrupoId);

   if (this.$route.params.id) {
    this.model.patTipoBemId = Number(this.$route.params.id);
   }

   this.loadingSave = true;

   PatTipoBemService.inserirAtualizar(this.model)
    .then(x => {
     toastService.alertaSucesso('Dados registrados com sucesso!');
     this.reloadRoute(x.data.codigo);
    })
    .catch((error) => {
     console.error("Erro ao salvar PatTipoBem:", error);
     toastService.alertaErro('Ocorreu um erro ao executar a ação.');
    })
    .finally(() => {
     this.loadingSave = false;
    });
  }
 },

 mounted() {
  this.setPatGrupoIdFromRoute();
  this.carregarFormulario();
 },

 watch: {
  '$route.params.id': {
   handler() {
    this.setPatGrupoIdFromRoute();
    this.carregarFormulario();
    this.keyRV += 1;
   },
   immediate: true,
  },
  '$route.params.patGrupoId': {
   handler() {
    this.setPatGrupoIdFromRoute();
    this.keyRV += 1;
   },
   immediate: true,
  }
 }
});
</script>
